function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  fillRule: "evenodd",
  d: "M10.27 9.715H6.73c-.978 0-1.771.793-1.771 1.773v2.817c1.047.703 2.28 1.078 3.541 1.076 1.262.002 2.495-.373 3.542-1.076v-2.817c0-.47-.186-.921-.518-1.253-.332-.333-.783-.52-1.253-.52z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  d: "M8.5 9c1.173 0 2.124-.951 2.124-2.125S9.673 4.75 8.5 4.75c-1.173 0-2.125.951-2.125 2.125S7.326 9 8.5 9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  d: "M8.5 14.667c1.502 0 2.944-.597 4.006-1.66 1.063-1.063 1.66-2.504 1.66-4.007 0-1.503-.597-2.944-1.66-4.007-1.062-1.063-2.504-1.66-4.007-1.66-1.503 0-2.944.597-4.007 1.66C3.43 6.056 2.832 7.497 2.832 9c0 1.503.598 2.944 1.66 4.007 1.063 1.063 2.504 1.66 4.007 1.66zm0 1.416c-3.913 0-7.084-3.17-7.084-7.083 0-3.912 3.171-7.083 7.083-7.083 3.912 0 7.084 3.17 7.084 7.083 0 3.912-3.171 7.083-7.084 7.083z"
});

var SvgPersonCircle = function SvgPersonCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-circle.65d568af.svg";
export { ForwardRef as ReactComponent };